import EnvVars from "../env-vars"

const IS_QA = EnvVars.NODE_ENV === `qa`
export default IS_QA
